import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { AppService } from 'app/services/app/app.service';

@Component({
  selector: 'app-toasts',
  templateUrl: './toast.component.html',
  standalone: true,
	imports: [NgIf, NgTemplateOutlet, NgFor],
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  
  constructor(public appService: AppService) { 

  }
  
  isTemplate(toast) {
		return toast.textOrTpl instanceof TemplateRef;
	}
  

}
